export default function SectionExpandingCards(el) {
    const cards = el.querySelectorAll('.section-expanding-cards__card');

    // in some cases the offset height was incorrect due to page not being fully drawn.
    setTimeout(() => {
        cards.forEach(card => {
            const lowerContentBlock = card.querySelector('.section-expanding-cards__content-lower');
            lowerContentBlock.style.bottom = `-${lowerContentBlock.offsetHeight - 100}px`;
        });
    }, 750);
}
